import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const AutoRajaDeleteData = ({ navigateToPath }) => (
  <LegalPageLayout
    route="autoraja-delete-data"
    kicker="Legal"
    title="AutoRaja Data Deletion Requests"
    navigateToPath={navigateToPath}
  >
    <p className="legal-lead">
      If you would like to request deletion of data associated with your use of
      AutoRaja, please contact us at{' '}
      <a href="mailto:contact@mixout.in?subject=AutoRaja%20Data%20Deletion%20Request">
        contact@mixout.in
      </a>{' '}
      with the subject line:
    </p>

    <div className="info-panel legal-callout">
      <p className="legal-callout-label">Email subject line</p>
      <p className="legal-callout-value">AutoRaja Data Deletion Request</p>
    </div>

    <h2 id="what-to-include">What To Include</h2>
    <p>Please include, where possible:</p>
    <ul className="legal-list">
      <li>your device platform (iOS or Android)</li>
      <li>your device model</li>
      <li>app version</li>
      <li>approximate date of last use</li>
      <li>any relevant purchase or support details</li>
      <li>a description of the data you want deleted</li>
    </ul>

    <h2 id="data-we-may-delete">Data We May Delete</h2>
    <ul className="legal-list">
      <li>support communications you ask us to remove, where permitted</li>
      <li>
        gameplay or app-related records we control and can reasonably associate
        with your request
      </li>
      <li>
        other user data under our control, subject to technical and legal
        limitations
      </li>
    </ul>

    <h2 id="data-that-may-be-retained">Data That May Be Retained</h2>
    <ul className="legal-list">
      <li>
        information required for legal, tax, fraud-prevention, security, or
        compliance purposes
      </li>
      <li>backup or archival data retained for a limited period</li>
      <li>aggregated or anonymized information that does not identify you</li>
    </ul>

    <h2 id="response-time">Response Time</h2>
    <p>
      We process deletion requests within a reasonable period, subject to
      verification and any applicable legal or technical constraints.
    </p>

    <h2 id="related">Related Pages</h2>
    <ul className="legal-list">
      <li>
        <a
          href="/autoraja/privacy"
          onClick={(event) => {
            event.preventDefault();
            navigateToPath('/autoraja/privacy');
          }}
        >
          Privacy Policy
        </a>
      </li>
      <li>
        <a
          href="/autoraja/support"
          onClick={(event) => {
            event.preventDefault();
            navigateToPath('/autoraja/support');
          }}
        >
          AutoRaja Support
        </a>
      </li>
    </ul>
  </LegalPageLayout>
);

export default AutoRajaDeleteData;
